import { useEffect, useRef, useState } from "preact/hooks";
import { BetEvent } from "../../../store/betFeedStore";
import {
  BetAvatar,
  Multiplier,
  TableCell,
  TableRow,
  Typography,
  WinAmount,
} from "../../ui";
import css from "./BetEntry.module.scss";

interface BetEntryProp {
  bet: BetEvent;
  size?: number;
}
const getScoreColor = (value: number | string | null) => {
  if (value === null || value === 0) return;
  return {
    border: `border-blue`,
    outline: `outline-blue`,
    bg: `bg-blue`,
  };
};
export const BetEntry = ({ bet, size }: BetEntryProp) => {
  const colors = getScoreColor(bet.multiplier);

  const prevMultRef = useRef<number>(0);
  const [phase, setPhase] = useState<"hidden" | "visible" | "fading">("hidden");
  const leaveTimerRef = useRef<number | null>(null);
  const cleanupTimerRef = useRef<number | null>(null);

  useEffect(() => {
    const current = Number(bet.multiplier ?? 0);
    const prev = Number(prevMultRef.current ?? 0);

    if (prev === 0 && current !== 0) {
      if (leaveTimerRef.current) window.clearTimeout(leaveTimerRef.current);
      if (cleanupTimerRef.current) window.clearTimeout(cleanupTimerRef.current);

      setPhase("visible");

      leaveTimerRef.current = window.setTimeout(() => {
        setPhase("fading");
        cleanupTimerRef.current = window.setTimeout(() => {
          setPhase("hidden");
        }, 500);
      }, 2250);
    }

    if (current === 0) {
      if (leaveTimerRef.current) window.clearTimeout(leaveTimerRef.current);
      if (cleanupTimerRef.current) window.clearTimeout(cleanupTimerRef.current);
      setPhase("hidden");
    }

    prevMultRef.current = current;

    return () => {
      if (leaveTimerRef.current) window.clearTimeout(leaveTimerRef.current);
      if (cleanupTimerRef.current) window.clearTimeout(cleanupTimerRef.current);
    };
  }, [bet.multiplier]);

  return (
    <TableRow
      key={bet.id}
      className={`${css.row} ${Number(bet.multiplier ?? 0) !== 0 ? colors?.bg : ""} ${phase === "visible" ? colors?.border : ""} ${phase === "fading" ? css.leaving : ""}`}
    >
      <TableCell className={css.cell}>
        <BetAvatar
          size={size}
          avatar={`${bet?.avatar}.png`}
          classNameAvatar={phase === "visible" ? colors?.outline : undefined}
          username={bet?.nickname}
        />
      </TableCell>
      <TableCell className={css.cell}>
        <Typography variant="caption2" color="light-grey">
          {bet.amount.toFixed(2)}
        </Typography>
      </TableCell>
      <TableCell className={css.cell}>
        <Multiplier value={bet.multiplier} isMyBet />
      </TableCell>
      <TableCell className={css.cell}>
        <WinAmount amount={bet.payout} />
      </TableCell>
    </TableRow>
  );
};
